<template>
  <div class="country-selector">
    <button aria-label="country-selector" @click="toggle">
      {{ translate('Countries') }}
    </button>

    <div ref="dropdown" v-show="open" class="country-selector__dropdown">
      <JluIcon class="country-selector__close" variant="close" @click="open = false" />

      <div class="country-selector__container">
        <div class="country-selector__header">
          {{
            translate(
              'Choose your preferences and find exciting, senior-level jobs in ##countries##+ countries',
              {
                countries: 40,
              },
            )
          }}
        </div>
        <div class="country-selector__body">
          <template v-for="(group, group_index) in regions">
            <div class="country-selector__group" :key="`group${group_index}`">
              <p class="country-selector__title" v-text="group.title" />

              <ul class="country-selector-list">
                <template v-for="(item, index) in group.options">
                  <li class="country-selector-list__item" :key="`item${index}`">
                    <button
                      class="country-selector-list__btn"
                      :class="{
                        'country-selector-list__btn_active': country?.value === item.value,
                      }"
                      @click="switchLanguage(item.value)"
                    >
                      {{ item.label }}
                    </button>
                  </li>
                </template>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { JluIcon } from '@jobleads-frontend/ui_library';

export default {
  name: 'CountrySelector',
  components: { JluIcon },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters({
      navigationUrlList: 'navigationUrlList',
      getCountryByCountryValue: 'country/getCountryByCountryValue',
      country: 'country/currentCountry',
      language: 'language',
    }),
    // regions() {
    //   const { translate } = this;
    //   return [
    //     {
    //       title: translate('America'),
    //       options: [
    //         { label: translate('Argentina'), value: 'ARG' },
    //         { label: translate('Brazil'), value: 'BRA' },
    //         { label: translate('Canada'), value: 'CAN' },
    //         { label: translate('Chile'), value: 'CHL' },
    //         { label: translate('Colombia'), value: 'COL' },
    //         { label: translate('Mexico'), value: 'MEX' },
    //         { label: translate('Peru'), value: 'PER' },
    //         { label: translate('United States'), value: 'USA' },
    //         { label: translate('Venezuela'), value: 'VEN' },
    //       ],
    //     },
    //     {
    //       title: translate('Europe'),
    //       options: [
    //         { label: translate('Austria'), value: 'AUT' },
    //         { label: translate('Belgium'), value: 'BEL' },
    //         { label: translate('Denmark'), value: 'DNK' },
    //         { label: translate('Finland'), value: 'FIN' },
    //         { label: translate('France'), value: 'FRA' },
    //         { label: translate('Germany'), value: 'DEU' },
    //         { label: translate('Ireland'), value: 'IRL' },
    //         { label: translate('Italy'), value: 'ITA' },
    //         { label: translate('Netherlands'), value: 'NLD' },
    //         { label: translate('Norway'), value: 'NOR' },
    //         { label: translate('Poland'), value: 'POL' },
    //         { label: translate('Portugal'), value: 'PRT' },
    //         { label: translate('Spain'), value: 'ESP' },
    //         { label: translate('Sweden'), value: 'SWE' },
    //         { label: translate('Switzerland'), value: 'CHE' },
    //         { label: translate('United Kingdom'), value: 'GBR' },
    //       ],
    //     },
    //     {
    //       title: translate('Asia'),
    //       options: [
    //         { label: translate('Bahrain'), value: 'BHR' },
    //         { label: translate('Hong Kong'), value: 'HKG' },
    //         { label: translate('India'), value: 'IND' },
    //         { label: translate('Indonesia'), value: 'IDN' },
    //         { label: translate('Kuwait'), value: 'KWT' },
    //         { label: translate('Malaysia'), value: 'MYS' },
    //         { label: translate('Oman'), value: 'OMN' },
    //         { label: translate('Pakistan'), value: 'PAK' },
    //         { label: translate('Philippines'), value: 'PHL' },
    //         { label: translate('Qatar'), value: 'QAT' },
    //         { label: translate('Saudi Arabia'), value: 'SAU' },
    //         { label: translate('Singapore'), value: 'SGP' },
    //         { label: translate('Turkey'), value: 'TUR' },
    //         { label: translate('United Arab Emirates'), value: 'ARE' },
    //       ],
    //     },
    //     {
    //       title: translate('Oceania'),
    //       options: [
    //         { label: translate('Australia'), value: 'AUS' },
    //         { label: translate('New Zealand'), value: 'NZL' },
    //       ],
    //     },
    //     {
    //       title: translate('Africa'),
    //       options: [{ label: translate('South Africa'), value: 'ZAF' }],
    //     },
    //   ];
    // },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    switchLanguage(countryCode) {
      window.location.replace(
        `/switchLanguage/${this.language}/${countryCode}?redirectBack=${encodeURIComponent(
          window.location.href,
        )}`,
      );
    },
  },
};
// const dropdown = ref(null);
// onClickOutside(dropdown, () => (open.value = false));
</script>
<style lang="scss">
@import './CountrySelector.scss';
</style>
